module.exports = __webpack_public_path__ + "static/fonts/iconfont.1cea4a68.eot";